import React, { forwardRef, useState } from "react";
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';

interface ITabbedContent extends IBuildrProps {
    children: any;
}

export default styled(forwardRef((props: ITabbedContent, ref: any) => {
    const { cmsId, editorClassObj, className, children } = props;

    const [activeTab, setActiveTab] = useState(0);
    const [showing, setShowing] = useState(0);
    const [activeAccordion, setActiveAccordion] = useState(null);


    // Removes class to trigger fade out
    const clickHandler = (index) => {
        setShowing(index);

        // Sets a timeout to show selected tab after fade out
        setTimeout(() => {
            setActiveTab(index);
        }, 300);
    }

    // Changes selected accordion for mobile
    const accordionHandler = (index) => {
        setActiveAccordion(index === activeAccordion ? null : index);
    }

    return (
        <div ref={ref} data-id={cmsId} className={cx('row', className, editorClassObj)}>
            <div className="col">
                {children &&
                    <div className="tab-titles d-none d-lg-flex justify-content-center">
                        {children.map((tab, index) => {
                            return (
                                <p key={index} onClick={() => clickHandler(index)} className={cx('px-0', {active: activeTab === index})}>
                                    <span className="d-block position-relative px-4">{tab.props.tabTitle}</span>
                                </p>
                            )
                        })}
                    </div>
                }
                <div className="tabbed-content-wrap d-flex flex-wrap">
                    {React.Children.map(children,(category, index) => {
                        return React.cloneElement(category, {
                            setActiveTab,
                            tabId: index,
                            active: activeTab === index,
                            showing: showing === index,
                            activeAccordion: activeAccordion === index,
                            setActiveAccordion: accordionHandler
                        });
                    })}
                </div>
            </div>

        </div>
    );
}))`

.tab-titles {
    border-bottom: 3px solid #E2E2E2;
    margin-bottom: 2.5rem;

    p {
        font-family: "National2", sans serif;
        margin: 0;
        font-size: 1rem;
        padding-right: 2rem;
        cursor: pointer;
        font-weight: 500;

        span {
            padding-bottom: 16px;
            &::after {
                content: '';
                display: none;
                width: 100%;
                height: 3px;
                bottom: -3px;
                left:0;
                position: absolute;
            }
        }
        &:hover {
            color: var(--pebble);
            font-weight: 600;

            span {
                &::after {
                    display: block;
                    background: var(--pebble);
                }
            }
        }
        &.active {
            color: black;
            font-weight: 600;
            span {
                &::after {
                    display: block;
                    background: #CE202E;
                }
            }
        }
    }
}

@media(max-width:992px) {
    .tabbed-content-wrap {
        border-top: 1px solid black;
    }
}
`;
